import { useDispatch, useSelector } from 'react-redux'
import { selectTranslations } from '../../services/i18n/i18nSlice'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';

import './Exams.css'
import { fetchExam } from './ExamApi';
import { setLoading } from '../../services/global/globalSlice';
import ConfirmModal from '../../components/_modals/ConfirmModal';
import ExamTable from './_components/ExamTable';
import { Form, InputGroup, Tab, Tabs } from 'react-bootstrap';
import ScoreboardTable from './_components/ScoreboardTable';
import SearchExamInput from './_components/SearchExamInput';
import Button from '../../components/Button';

export default function UserExamsSearch(props) {

    const t = useSelector(selectTranslations)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [searchData, setSearchData] = useState({})
    const [isUpdated, setIsUpdated] = useState(false)
    const [confirmModal, setConfirmModal] = useState({
        title: "",
        text: "",
        onClose: null,
        onConfirm: null,
        confirmCta: "",
        closeCta: ""
    })

    const STATUS_OPTIONS = [
    'starting',
    'in_progress',
    'correction_in_progress',
    'completed',
    'rejected',
    'review_needed',
    ]

    // --- piccolo componente riusabile ---
    function StatusFilter({ value, onChange }) {
    return (
        <div className="d-flex align-items-center gap-2 ms-3">
        <Form.Label className="mb-0">Status</Form.Label>
        <InputGroup style={{ maxWidth: 340 }}>
            <Form.Select
            aria-label="Filter by status"
            value={value ?? ''}
            onChange={(e) => onChange(e.target.value || null)}
            >
            <option value="">— all —</option>
            {STATUS_OPTIONS.map((s) => (
                <option key={s} value={s}>{s}</option>
            ))}
            </Form.Select>
        </InputGroup>
        </div>
    )
    }

    const setFilter = (type, payload) => {
        if (type === 'exam_id') {
        setSearchData((prev) => ({ ...prev, exam_id: payload?.exam_id || null }))
        }
        if (type === 'state') {
        setSearchData((prev) => ({ ...prev, state: payload || null }))
        }
    }

    return (
        <section id="examsScreen">
            {
                <>
                    <div className='d-flex align-items-center mb-3'>
                        <SearchExamInput onSelectExam={(e) => setFilter('exam_id', e)} />
                        <StatusFilter
                            value={searchData.state ?? ''}
                            onChange={(val) => setFilter('state', val)}
                            onClear={() => setFilter('state', null)}
                        />
                        {searchData?.exam_id || searchData?.state ? (
                            <Button variant="outline-secondary" onClick={() => setSearchData({})}>
                                Reset
                            </Button>
                        ) : null}
                    </div>
                    
                    <ExamTable 
                        examId = {searchData?.exam_id}
                        state = {searchData?.state}
                        isSearch = {true}
                    />
                    <ConfirmModal props={confirmModal}/>
                    
                </>
            }
            
        </section>
    )
}